module.exports = __webpack_public_path__ + "img/product1.52c2b891.jpg";